import { formatMrnForDisplay } from '@/utils/orderFormUtils'
import { format } from 'timeago.js'

function formatLastActivity(updatedAt: string | null | undefined): string | null {
  if (!updatedAt?.trim()) return null
  const parsed = Date.parse(updatedAt)
  if (Number.isNaN(parsed)) return null
  return format(new Date(parsed))
}

export function buildDiscardOrderConfirmCopy(params: {
  patientName: string
  patientMrn: string
  draftOwnerDisplayName?: string | null
  draftUpdatedAt?: string | null
  currentUserId?: string | null
  draftOwnerUserId?: string | null
}): { title: string; description: string } {
  const mrnDisplay = formatMrnForDisplay(params.patientMrn)
  const title = `Discard the in-progress order for ${params.patientName}${mrnDisplay ? ` (${mrnDisplay})` : ''}?`

  const lines = ['All entered data for this draft will be permanently deleted. This cannot be undone.']

  const ownerId = params.draftOwnerUserId?.trim()
  const currentId = params.currentUserId?.trim()
  const showOwner = ownerId && currentId && ownerId !== currentId

  if (showOwner) {
    const ownerLabel = params.draftOwnerDisplayName?.trim() || ownerId
    const lastActivity = formatLastActivity(params.draftUpdatedAt)
    lines.push(
      lastActivity
        ? `This draft belongs to ${ownerLabel} (last updated ${lastActivity}).`
        : `This draft belongs to ${ownerLabel}.`
    )
  }

  return { title, description: lines.join(' ') }
}
